import React, { useEffect, useState } from "react";
import { Title } from "../../../../../../stories/Title/Title";
import { Label } from "../../../../../../stories/Label/Label";
import Close from "../../../../../../images/Close.svg";
import { Button } from "../../../../../../stories/Button/Button";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";

import useUrlParams from "../../../../../../customHooks/useUrlParams";
import {
  EMPTY_STRING,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  debouncedDelay,
  emptyMessage,
} from "../../../../../../utils/constants";
import { StyledDatagrid } from "../../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../../styles/Variables";
import {
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import { ColumnVisibilityFor } from "../../../../../../utils/Enum.Datagrid";
import {
  AtsStckItemOrderField,
  GetItemsResult,
  GetItemsVars,
  ItemQueryType,
  filterDataType,
} from "../../items/queries/types";
import { GetItems } from "../../items/queries/queries";
import { useLazyQuery, useMutation } from "@apollo/client";
import { OrderDirection } from "../../../../../../utils/commonQueryTypes";
import NoData from "../../../../../../images/NoData.svg";
import { TableHeaderProps } from "../../../../../../utils/types";
import { Checkbox } from "@mui/material";

import Input from "../../../../../../stories/Input/Input";
import ItemGroupSelect from "../../../../../../customComponents/ItemGroupSelect";
import {
  getModifiedScrollHeight,
  handleMUISelectEvent,
} from "../../../../../../utils/UtilFunctions";
import ItemCategorySelect from "../../../../../../customComponents/ItemCategorySelect";
import UoMSelect from "../../../../../../customComponents/UoMSelect";
import { CustomDrawer } from "../../../../../../styles/CustomDrawerStyles";

import { GetStckItemLdgrAssociDetails } from "../queries/queries";
import {
  AtsStckItemLdgrAssoicEdge,
  AtsStckItemLdgrAssoicOrderField,
  GetStckItemLdgrAssociDetailsResult,
  GetStckItemLdgrAssociDetailsVar,
  ItemLdgrAssoicQueryType,
} from "../queries/types";

import { Operation, empType } from "../../../../../../utils/Enum.types";
import DeleteModal from "../../../../../../customComponents/DeleteModal";
import MessageModal from "../../../../../../customComponents/MessageModal";
import LoadingModal from "../../../../../pages/LoadingModal";
import {
  AtsAcLdgrOrderField,
  LdgrQueryType,
} from "../../supplier/queries/types";
import { GetSuppliers } from "../../supplier/queries/queries";
import useLabels from "../../../../../../customHooks/useLabels";
import {
  DeleteEmpLdgrAssoicResult,
  DeleteEmpLdgrAssoicVar,
  EmpLdgrAssoicOrderField,
} from "./queries/types";
import { selectedSupplierType } from "./AssociateEmps";
import {
  EmpMasterEdge,
  EmpMasterOrderField,
  EmpQueryType,
  GetEmpResult,
  GetEmpVars,
} from "../../../users/queries/types";
import AssignEmps from "./AssignEmps";
import { DeleteEmpLdgrAssoic } from "./queries/mutations";
import { GetEmp } from "../../../users/queries/queries";
import { useDebounce } from "../../../../../../customHooks/useDebounce";

interface Props {
  selectedSupplier: selectedSupplierType;
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const ViewEmps = ({ selectedSupplier, setModalFlag }: Props) => {
  const { Users } = useAssetTableJson();
  const [assign, setAssign] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const { user_details } = useLoggedInUserDetails();

  const { customer_id, company_id } = useUrlParams();
  const [selectedItems, setSelectedItems] = useState<number[]>([]);
  const [message, setMessage] = useState(emptyMessage);
  const [searchData, setSearchData] = useState("");
  const debouncedSearch = useDebounce(searchData, debouncedDelay);
  const [filterData, setFilterData] = useState<filterDataType>({
    ItemGroupId: 0,
    ItemCategoryId: 0,
    UoMId: 0,
  });
  const [rows, setRows] = useState<GridValidRowModel[]>([]);
  const [employees, setEmployees] = useState<EmpMasterEdge[]>([]);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);

  // const [getStckItemLdgrAssociDetails, { data, loading, fetchMore }] =
  //   useLazyQuery<
  //     GetStckItemLdgrAssociDetailsResult,
  //     GetStckItemLdgrAssociDetailsVar
  //   >(GetStckItemLdgrAssociDetails);

  // const [deleteItemLdgrAssociByLdgr, { loading: deleteLoading }] = useMutation<
  //   DeleteItemLdgrAssociByLdgrResult,
  //   DeleteItemLdgrAssociByLdgrVar
  // >(DeleteItemLdgrAssociByLdgr, {
  //   onError: (err) => {
  //     setMessage({
  //       flag: true,
  //       message: (err as Error).message,
  //       operation: Operation.NONE,
  //     });
  //   },
  // });

  const [getEmpLdgrAssociDetails, { data, loading, fetchMore }] = useLazyQuery<
    GetEmpResult,
    GetEmpVars
  >(GetEmp);

  const [deleteEmpLdgrAssoic, { loading: deleteLoading }] = useMutation<
    DeleteEmpLdgrAssoicResult,
    DeleteEmpLdgrAssoicVar
  >(DeleteEmpLdgrAssoic);

  const handleCheckboxChange = (id: number) => {
    setSelectedItems(
      (prevSelected) =>
        prevSelected.includes(id)
          ? prevSelected.filter((itemId) => itemId !== id) // Remove if already selected
          : [...prevSelected, id] // Add if not selected
    );
  };

  const dynamicHeaders: TableHeaderProps[] = Users.List.map((header) => ({
    headerName: header.headerName,
    field: header.field,
    headerAlign: header.headerAlign as GridAlignment,
    align: header.align as GridAlignment,
    flex: header.flex,
    hideable: header.hideable,
    cellClassName: header.cellClassName,
    renderCell: (params) => {
      if (header.field === "id") {
        return (
          <>
            <Checkbox
              value={params.row}
              checked={selectedItems.includes(params.row.user_id)}
              onChange={() => handleCheckboxChange(params.row.user_id)}
              inputProps={{ "aria-label": "controlled" }}
            />
          </>
        );
      }

      return params.value;
    },
  }));
  const columns: GridColDef[] = [...dynamicHeaders];

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(ColumnVisibilityFor.VIEW_SUPPLIER);
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.VIEW_SUPPLIER,
      JSON.stringify(newModel)
    );
  };

  const handleClear = () => {
    setSelectedItems([]);
  };

  const handleClose = () => {
    handleClear();
    setMessage(emptyMessage);
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetEmp.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newEmp) => {
          const filteredStudent = employees.find(
            (employee) => employee.node.id === newEmp.node.id
          );
          if (filteredStudent) {
            return {
              ...newEmp,
              node: {
                ...newEmp.node,
              },
            };
          }
          return newEmp;
        });
        setEmployees(updatedNewData);
        setRows(
          updatedNewData.map(({ node }, index) => ({
            id: index + 1,
            name: node.name,
            mobile: node.mobile,
            email: node.email,
            user_type: "",
            user_id: node.id,
            customerName: node.customer.name,
          }))
        );
      } else {
        setEmployees(newData);
        setRows(
          newData.map(({ node }, index) => ({
            id: index + 1,
            name: node.name,
            mobile: node.mobile,
            email: node.email,
            user_type: node.empType,
            user_id: node.id,
            customerName: node.customer.name,
          }))
        );
      }
      setEndCursor(data.GetEmp.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetEmp.edges;
              const pageInfo = fetchMoreResult.GetEmp.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetEmp.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetEmp: {
                  edges: [...employees, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetEmp.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && rows.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rows]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (customer_id) {
          await getEmpLdgrAssociDetails({
            variables: {
              customer_id,

              after: null,
              first: ROWS_PER_PAGE,
              input: {
                companyID: 0,
                ldgrID: selectedSupplier.supplierId,
                queryType: EmpQueryType.BY_TYPE,
                siteID: 0,
                subsidiaryID: 0,
                empType: [empType.TECHNICIAN, empType.VENDOR_MANAGER],
              },
              name: debouncedSearch,
              orderBy: {
                direction: OrderDirection.ASC,
                field: EmpMasterOrderField.NAME,
              },
            },
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [
    customer_id,
    getEmpLdgrAssociDetails,
    selectedSupplier.supplierId,
    debouncedSearch,
    filterData,
  ]);

  const HandleDelete = async () => {
    try {
      if (customer_id) {
        setDeleteModal(!deleteModal);
        deleteEmpLdgrAssoic({
          variables: {
            customer_id,

            user_details,
            ldgrID: selectedSupplier.supplierId,
            empIds: selectedItems,
          },
          refetchQueries: [
            {
              query: GetEmp,
              variables: {
                customer_id,

                after: null,
                first: ROWS_PER_PAGE,
                input: {
                  companyID: 0,
                  ldgrID: selectedSupplier.supplierId,
                  queryType: EmpQueryType.BY_TYPE,
                  siteID: 0,
                  subsidiaryID: 0,
                  empType: [empType.TECHNICIAN],
                },
                name: debouncedSearch,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: EmpMasterOrderField.NAME,
                },
              },
            },
            {
              query: GetEmp,
              variables: {
                after: null,
                customer_id: customer_id ? customer_id : 0,
                first: ROWS_PER_PAGE,
                input: {
                  queryType: EmpQueryType.NOT_ASSOICATED_VENDOR_USERS,
                  empType: [empType.TECHNICIAN],
                  companyID: 0,
                  ldgrID: 0,
                  siteID: 0,
                  subsidiaryID: 0,
                },
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: EmpMasterOrderField.NAME,
                },

                name: debouncedSearch,
              },
            },
            {
              query: GetSuppliers,
              variables: {
                after: null,
                customer_id,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsAcLdgrOrderField.CREATED_AT,
                },

                name: EMPTY_STRING,
                input: {
                  query_type: LdgrQueryType.ALL,
                  itemID: 0,
                },
              },
            },
          ],
        }).then(({ data }) => {
          if (data && data.DeleteEmpLdgrAssoic) {
            setMessage({
              flag: true,
              message: `Employees Deleted Sucessfully`,
              operation: Operation.DELETE,
            });
          }
        });
      }
    } catch (err) {
      console.error((err as Error).message);
    }
  };
  const { itemLabel, ledgerLabel } = useLabels();
  return (
    <>
      <div className="assign-supplier">
        <div className="assign-supplier__title">
          <Title>View Associated Employee to {ledgerLabel} details</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        <div className="assign-supplier__header">
          <div className="assign-supplier__header--grid">
            <Label>{ledgerLabel} Name</Label>
            <span>:</span>
            <b>{selectedSupplier.supplierDesc}</b>
          </div>
        </div>
        <Title variant="subtitle1">
          {deleteModal ? `Delete Employee` : `Assign Employee`}
        </Title>

        <div className="associate-supplier__tableblock--sup">
          {rows.length ? (
            <StyledDatagrid
              columns={columns}
              rows={rows}
              rowHeight={TABLE_ROW_HEIGHT}
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={handleColumnVisibilityChange}
              initialState={{
                columns: {
                  columnVisibilityModel: columnVisibilityModel,
                },
              }}
              disableRowSelectionOnClick
              hideFooter
            />
          ) : (
            <>
              <img src={NoData} alt="" className="nodata-image" />
            </>
          )}
        </div>

        <div className="row g-0">
          <div className="col">
            {deleteModal ? (
              <>
                <Button mode="save" />
                <Button mode="clear" onClick={handleClear} />
              </>
            ) : (
              <>
                <Button
                  mode="assign"
                  onClick={() => {
                    setAssign(!assign);
                  }}
                />
                <Button
                  mode="delete"
                  onClick={() => {
                    setDeleteModal(!deleteModal);
                  }}
                  disabled={!selectedItems.length}
                />
              </>
            )}

            <Button mode="cancel" onClick={() => setModalFlag(false)} />
          </div>
          <div className="col-4 flex-end">
            <div className="overall-total-count">
              Selected Employees <b>{selectedItems.length}</b>
            </div>
          </div>
        </div>
      </div>
      <CustomDrawer
        anchor="right"
        open={assign}
        onClose={() => setAssign(!assign)}
      >
        <AssignEmps
          selectedSupplier={selectedSupplier}
          setModalFlag={setAssign}
        />
      </CustomDrawer>

      <DeleteModal
        id={0}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={HandleDelete}
      />
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal flag={!searchData && loading} />
    </>
  );
};

export default ViewEmps;
